<template>
  <ValidationObserver ref="observer">
    <form
      id="signup-form"
      class="shadow-lg p-4 mb-5 bg-white rounded"
      v-on:submit.prevent="submit"
    >
      <h4>Бүртгүүлэх</h4>
      <p class="signup-hint">
        Нэвтрэх утасны дугаар болон нууц үгээ оруулаад бүртгүүлээрэй.
      </p>

      <div class="col-12 form-group">
        <label class="col-form-label col-form-label-lg"
          >Нэвтрэх утасны дугаар <span class="text-danger">*</span></label
        >
        <ValidationProvider
          :rules="{ required: true, regex: /^[0-9]{8}$/ }"
          v-slot="{ errors }"
        >
          <b-form-input
            name="phone"
            v-model.trim="data.loginName"
            :class="{ 'is-invalid': errors[0] }"
            type="tel"
            inputmode="numeric"
            placeholder="8 оронтой утасны дугаар"
          />
          <p class="valid-span" v-if="errors[0]">
            Утасны дугаар 8 оронтой тоо байх ёстой!
          </p>
        </ValidationProvider>
      </div>

      <div class="col-12 form-group">
        <label class="col-form-label col-form-label-lg"
          >Нууц үг <span class="text-danger">*</span></label
        >
        <ValidationProvider vid="confirm" rules="required|min:4" v-slot="{ errors }">
          <b-form-input
            v-model.trim="data.password"
            :class="{ 'is-invalid': errors[0] }"
            type="password"
          />
          <p class="valid-span" v-if="errors[0] && data.password.length === 0">
            Нууц үгээ оруулна уу
          </p>
          <p class="valid-span" v-else-if="errors[0]">
            Нууц үг хамгийн багадаа 4 тэмдэгттэй байх ёстой
          </p>
        </ValidationProvider>
      </div>

      <div class="col-12 form-group">
        <label class="col-form-label col-form-label-lg"
          >Нууц үг давтах <span class="text-danger">*</span></label
        >
        <ValidationProvider
          rules="required|min:4|password:@confirm"
          v-slot="{ errors }"
        >
          <b-form-input
            v-model.trim="data.passwordRepeat"
            type="password"
            :class="{ 'is-invalid': errors[0] }"
          />
          <p class="valid-span" v-if="errors[0] && data.passwordRepeat.length === 0">
            Нууц үгээ давтан оруулна уу
          </p>
          <p
            class="valid-span"
            v-else-if="errors[0] && data.passwordRepeat.length < 4"
          >
            Нууц үг хамгийн багадаа 4 тэмдэгттэй байх ёстой
          </p>
          <p class="valid-span" v-else-if="errors[0]">
            Нууц үг таарахгүй байна
          </p>
        </ValidationProvider>
      </div>

      <div class="col-12 form-group">
        <div class="confirm" v-b-modal.modal-scrollable>
          <b-icon v-if="isConfirm" icon="check2-square"> </b-icon>
          <b-icon v-else icon="square"> </b-icon>
          <a>Би үйлчилгээний нөхцөлийг зөвшөөрч байна.</a>
        </div>
        <Confirm @isConfirmed="isConfirmed" @disConfirmed="disConfirmed" />
      </div>

      <div class="col-12 form-group text-center">
        <button
          class="btn col-12 btn-success btn-lg btn-block"
          type="submit"
          variant="primary"
        >
          <span>Бүртгүүлэх</span>
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script scoped>
import { extend } from "vee-validate";
import OwnerService from "../api-services/owner.service.js";
import Confirm from "./confirm.vue";
import Swal from "sweetalert2";
import swal from "sweetalert";

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Нууц үг таарахгүй байна",
});

const Toast = Swal.mixin({
  toast: true,
  animation: true,
  position: "top-end",
  timer: 3000,
  timerProgressBar: true,
  showConfirmButton: false,
});
export default {
  name: "SignupForm",
  data: () => {
    return {
      isConfirm: false,
      UserName: "",
      data: {
        type: "student",
        loginName: "",
        password: "",
        passwordRepeat: "",
      },
    };
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        if (this.isConfirm) {
          this.sendData();
        } else {
          Toast.fire({
            icon: "warning",
            title: "Үйлчилгээний нөхцөлтэй танилцаарай!",
          });
        }
      } else {
        Toast.fire({
          icon: "warning",
          title: "Бүртгэлийн мэдээлэл дутуу байна!",
        });
      }
    },

    isConfirmed: function () {
      this.isConfirm = true;
    },

    disConfirmed: function () {
      this.isConfirm = false;
    },

    sendData: function () {
      const that = this;
      OwnerService.createRegister({
        data: {
          type: this.data.type,
          loginName: this.data.loginName,
          password: this.data.password,
          passwordRepeat: this.data.passwordRepeat,
        },
      })
        .then(function (response) {
          if (response.data !== "success") {
            that.UserName = response.data.username[0].slice(10, 18);
            if (that.UserName === that.data.loginName) {
              Toast.fire({
                icon: "warning",
                title: "Таны утасны дугаар бүртгэлтэй байна!",
              });
            }
          } else if (response.data === "success") {
            swal("Бүртгэл амжилттай", "Та одоо нэвтэрч орж болно.", "success", {
              closeOnClickOutside: false,
            }).then(() => {
              that.$router.push({
                name: "Login",
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Toast.fire({
            icon: "error",
            title: "Сүлжээний алдаа!",
          });
        });
    },
  },
  components: {
    Confirm,
  },
};
</script>

<style scoped>
#signup-form {
  font-family: "Roboto", sans-serif;
  padding: 40px;
  background-color: #ffffff;
  max-width: 460px;
  margin-right: auto;
  margin-left: auto;
}
h4 {
  text-align: center;
  font-weight: 500;
  margin-top: 10px;
}
.signup-hint {
  font-size: 0.9em;
  color: #6d6d6d;
  text-align: center;
  margin-bottom: 20px;
}
.confirm {
  font-size: 0.9em;
  margin-top: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.confirm a {
  margin-left: 3px;
}
.terms-link {
  display: inline-block;
  font-size: 0.85em;
  margin-top: 4px;
  margin-left: 25px;
  color: #22b353;
}
.terms-link:hover {
  text-decoration: underline;
}
.form-group {
  width: 100%;
  margin-bottom: 15px;
}
.col-form-label {
  font-size: 0.95em;
}
.form-group span.text-danger {
  color: #e20b0bad !important;
}
.valid-span {
  font-size: 80%;
  color: #e20b0bad;
  margin-top: 4px;
}
.btn-success {
  margin-top: 20px;
}
.b-icon {
  color: #22b353;
}
</style>
